import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { UtilsService, CompRouterService, TrainingService } from '../../helpers/services/index';
import { SharedSkillService } from '../trainings/shared-skill-component';
import { IcsDownloadService } from 'app/helpers/services/core/ics-download.service';
import { NgForm } from '@angular/forms';
import { time } from 'console';
declare var $: any;

@Component({
  selector: 'app-training-directive',
  templateUrl: './training-directive.component.html',
  styleUrls: ['./training-directive.component.scss'],
})

export class TrainingDirectiveComponent implements OnInit {
  @ViewChild('teaserSubjectInput') teaserSubjectInput!: ElementRef;
  searchString: any;
  loggedInUser: any;

  selectedSkills: any[] = []; 
  previousSkillTag: any;
  submitted: boolean = true;
  selectedTraining: any;
  teaserTitle: string;
  teaserDescription: string;
  imageUrls: string[] = ['https://styria-dev-public.s3-ap-south-1.amazonaws.com/Picture1_Kronos.png_ee4d2882-0123-43cf-81c1-51efdb3198a1.png',
    'https://styria-dev-public.s3-ap-south-1.amazonaws.com/Picture2_Kronos.png_c8f46f94-6c6d-4f3b-9987-de52a68331a6.png',
    'https://styria-dev-public.s3-ap-south-1.amazonaws.com/Picture3_Kronos.png_021b977d-8d6b-4fce-b531-f02b69223183.png',
    'https://styria-dev-public.s3-ap-south-1.amazonaws.com/Picture4_Kronos.png_724badcd-483d-45bc-afdb-b33704db463c.png',
    'https://styria-dev-public.s3-ap-south-1.amazonaws.com/Picture5_Kronos.png_4745a813-3426-487b-935d-783af4774a40.png',
    'https://styria-dev-public.s3-ap-south-1.amazonaws.com/Picture6_Kronos.png_8339bf42-b358-43bf-a598-7b59033075a8.png'];
  selectedImageUrl: string;
  @Input() generalEvents: any;
  @Input() filterCount: any;
  @Input() removedSkill: any;

  @Output() joinTraining = new EventEmitter<Object>();
  @Output() requestATraining = new EventEmitter<Object>();
  @Output() deleteTrainingRequest = new EventEmitter<Object>();
  @Output() closeTrainingRequest = new EventEmitter<Object>();
  @Output() goTo = new EventEmitter<Object>();
  @Output() removeAllFilters = new EventEmitter<Object>();
  @Output() skillTags = new EventEmitter<any>();

  constructor(public utils: UtilsService, public compRouter: CompRouterService, 
    private _cookieService: CookieService,
    private sharedSkillService: SharedSkillService,
    private icsDownloadService: IcsDownloadService,
    private trainingService: TrainingService
  ) {
    if (this._cookieService.get('loggedInUser') != undefined) {
      this.loggedInUser = JSON.parse(this._cookieService.get('loggedInUser'));
    }
  }

  ngOnInit() {
  }

  joinTrainer(id, i) {
    const trainingRequestDetails = {
      'trainingId': id,
      'index': i
    }
    this.joinTraining.emit(trainingRequestDetails);
  }

  requestTraining(id, i) {
    const requestDetails = {
      'trainingId': id,
      'index': i
    }
    this.requestATraining.emit(requestDetails);
  }

  deleteRequest(id) {
    const deleteRequest = {
      'id': id
    }
    this.deleteTrainingRequest.emit(deleteRequest);
  }

  closeRequest(id) {
    const closeRequest = {
      'id': id
    }
    this.closeTrainingRequest.emit(closeRequest);
  }

  routing(type, id) {
    let data = {
      type: type,
      id: id
    }
    this.goTo.emit(data);
  }

  clearFilters() {
    this.removeAllFilters.emit();
    this.sharedSkillService.clear();
  }


  toggleSelection(skill: any) {
    this.selectedSkills = this.sharedSkillService.getList();
    const isSkillSelected = this.selectedSkills.includes(skill.id);

    if (!isSkillSelected) {
        this.sharedSkillService.add(skill.id);
    } else {
        this.sharedSkillService.remove(skill.id);
    }
    this.emitSkillTags(skill);
  }


  isSelected(skill: any): boolean {
    this.selectedSkills = this.sharedSkillService.getList();
    return this.selectedSkills.includes(skill);

  }

  emitSkillTags(skill: any) {
    this.skillTags.emit(skill);
  }

  downloadIcsFile(training: any) {
    const startDateTime = training.time.replace(' ', 'T') + ':00Z';
    const calculatedStart = new Date(startDateTime);
  
    const calculatedEnd = new Date(calculatedStart.getTime() 
    + training.duration * 60 * 1000);
    const endDateTime = calculatedEnd.toISOString().replace('.000', '');
    const uid = 'fe-training-' + training.id + '-' + Date.now() + "@tarento" 

    this.icsDownloadService.downloadEvent({ uid: uid,
      start: new Date(startDateTime), 
      end: new Date(endDateTime), 
      summary: training.title, 
      description: training.description, 
      location: training.location, 
      filename:  training.title + ".ics"});
  }

  openTeaserModal(training: any) {
    $('#teaserModal').modal('show');

    this.selectedTraining = training;
    this.teaserTitle = training.title;
    this.teaserDescription = training.description;

    $('#teaserModal').off('shown.bs.modal').on('shown.bs.modal', () => {
      if (this.teaserSubjectInput && this.teaserSubjectInput.nativeElement) {
        this.teaserSubjectInput.nativeElement.focus();
      }
    });
  }

  submitTeaserForm(f: NgForm) {
    this.submitted = true;
    if (!f.valid) {
      Object.keys(f.controls).forEach(field => {
        const control = f.controls[field];
        control.markAsTouched({ onlySelf: true });
      });
      return;
    }
    if(f.value .teaserSubject.trim() === '' || f.value.teaserTitle.trim() === '' || 
      f.value.teaserDescription.trim() === '') {
      this.submitted = false;
      return;
    }

    let dateTimeStr = this.selectedTraining.time || '';
    let timeOnly = dateTimeStr.split(' ')[1] || '';
    const formattedTime = this.convertUtcTimeToIst12HourFormat(timeOnly);

    

    const teaserRequest = {
      teaserEmailSubject: f.value.teaserSubject,
      trainingTitle: f.value.teaserTitle,
      trainingDescription: f.value.teaserDescription,

      trainerName: this.selectedTraining.trainerFirstName + 
      ' ' +this.selectedTraining.trainerLastName,

      trainingDate: this.selectedTraining.date,
      trainingStartTime: formattedTime,
      trainingLink: this.selectedTraining.location,
      headerImage: this.selectedImageUrl || this.imageUrls[0]
    };
    this.trainingService.sendTrainingTeaserEmail(teaserRequest).subscribe((response: any) => {
      if(response.statusCode === 202) {
        this.utils.growlMessages('success', 'Teaser email request accepted and is being processed.');
        $('#teaserModal').modal('hide');
        f.resetForm();
        this.selectedImageUrl = '';
      } else {
        this.utils.growlMessages('error', 'Failed to send teaser email. Please try again later.');
         $('#teaserModal').modal('hide');
      }
    });
  }

  selectImage(imageUrl: string): void {
    this.selectedImageUrl = imageUrl;
  }

  private convertUtcTimeToIst12HourFormat(utcTimeStr: string): string {
    if (!utcTimeStr) {
      return '';
    }

    try {
      const [utcHourStr, utcMinuteStr] = utcTimeStr.split(':');
      const utcHours = parseInt(utcHourStr, 10);
      const utcMinutes = parseInt(utcMinuteStr, 10);

      if (isNaN(utcHours) || isNaN(utcMinutes)) {
        console.warn('Invalid UTC time string:', utcTimeStr);
        return '';
      }

      // Create a date at today's UTC midnight
      const utcDate = new Date(Date.UTC(1970, 0, 1, utcHours, utcMinutes));

      // Add IST offset (5.5 hours)
      const istMillis = utcDate.getTime() + (5.5 * 60 * 60 * 1000);
      const istDate = new Date(istMillis);

      let hours = istDate.getUTCHours(); // use getUTCHours to avoid local timezone effect
      const minutes = istDate.getUTCMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const twelveHour = hours % 12 || 12;
      const paddedMinutes = minutes < 10 ? '0' + minutes : minutes;

      return `${twelveHour}:${paddedMinutes} ${ampm}`;
    } catch (e) {
      console.error('Time conversion error:', e);
      return '';
    }
  }

isFutureDateTime(utcDateTimeStr: string): boolean {
  if (!utcDateTimeStr) return false;

  try {
    // Step 1: Convert string to UTC Date object
    const utcIso = utcDateTimeStr.replace(' ', 'T') + ':00Z';
    const utcDate = new Date(utcIso); // Interpreted as UTC

    // Step 2: Convert UTC time to IST (add 5.5 hours)
    const istTimeMillis = utcDate.getTime() + (5.5 * 60 * 60 * 1000);
    const istDate = new Date(istTimeMillis);

    // Step 3: Get current IST time
    const now = new Date();
    const currentIstTimeMillis = now.getTime();

    // Step 4: Compare
    return istTimeMillis > currentIstTimeMillis;
  } catch (e) {
    console.error('Invalid UTC datetime input:', utcDateTimeStr);
    return false;
  }
}






}
